module.exports = __webpack_public_path__ + "img/Stemness-PDAC_GSE202740.0fb9f20f.png";